import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Patient } from '../models/index';
import { Session, Ui } from '../services/index';
import { TranslateService } from '@ngx-translate/core';

declare function redirectToPhs(isTest: boolean): any;


@Component({
  selector: 'app-login',
  templateUrl: './login.html'
})

export class LoginComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  public isRequesting: boolean;
  msgType: string = '';
  message: string = '';
  isTest: boolean = false;
  constructor(private route: ActivatedRoute,
              private router: Router,
              public session: Session,
              private loader: Ui,
              public translate: TranslateService) {


  }

  ngOnInit() {
  //   this.translate.get('HELLO', {value: 'world'}).subscribe(res => {
  //     console.log(res);
  //     //=> 'hello world'
  // });

    if (!this.session.isAuthenticated) {
      redirectToPhs(false);
    }
    this.session.patient = new Patient();
    this.message = this.session.message;
    this.msgType = this.session.messageType;

  
    /*
    this.route.queryParams        
    .subscribe(params => {
        console.log('login params:' , params);
      this.message = params.msg;
       this.msgType = params.type; 
       console.log('this.msgType:' , this.msgType);
       console.log('this.message:' , this.message);
        return;
       
    });
    */
   console.log('this.msgType:' , this.msgType);
   console.log('this.message:' , this.message);
  }

  login() {
    this.loading = true;
    this.isRequesting = true;

    // this.loader.showLoadingIndicator(true);

    this.session.login(this.model.username, this.model.password)
      .subscribe((success) => {
        console.log('login response:', success);
        this.session.setAuthenticated(true);
        this.isRequesting = false;
        this.loading = false;
        this.router.navigate(['/dashboard']);
      }, ex => {
        console.log('Invalid Login Credentials:', ex);
        this.loading = false;
      });
  }

  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  signUp() {
    this.router.navigate(['/signup']);
  }
}
